import React, { Component } from 'react';
import { Formik } from 'formik';

import { Button, Col, Form, FormFeedback, FormGroup, Label, Input, Row, Card, CardBody, CardHeader } from 'reactstrap';
import * as Yup from 'yup';
import { connect } from 'react-redux'
import { isEmpty } from '../../../common/utils'

import { withRouter, Link } from 'react-router-dom'
import { updateEmployeeById, getCompanybyName, addEmployee } from '../../../actions/CompanyAction'
import { encodeforspace } from '../../../utils/helper';

class EmployeeTable extends Component {
  ValidationSchema = Yup.object().shape({
    // company_name: Yup.string()
    //   .required('Required'),
  });
  constructor(props) {
    super(props)
    this.state = {
      id: props.match.params.id
    }
  }

  onSubmit = (values, { setSubmitting, setErrors, setStatus, resetForm }) => {
    const { employee, company, growjo_id } = this.props
    if(!company){
      return this.props.history.push('/')
    }
    const { id } = this.state
    if (id == 'add') {
      this.props.addEmployee({ ...values, company_id: growjo_id })
        .then((res) => {
          this.props.getCompanybyName(company)
          this.props.history.push('/edit_company/'+ encodeforspace(company) +'/employee')
        }).catch(err => {
          console.log('err',err)
        })
    } else {
      this.props.updateEmployeeById(id, employee[id].id, values)
        .then((res) => {
          this.props.getCompanybyName(company)
          this.props.history.push('/edit_company'+ encodeforspace(company) +'/employee')
        })
    }
  }

  render() {
    const { id } = this.state
    const nullInput = {
      name: '',
      title: ''
    }
    const { employee } = this.props
    if (id != 'add' && isEmpty(employee)) this.props.history.push('/')

    const editData = (id == 'add') ? nullInput : employee[id]
    const {
      name,
      title
    } = editData
    return (
      <div className="animated fadeIn" style={{ height: "100%" }}>
        <Card style={{ height: "100%", margin: 0 }}>
          <CardHeader><h1 className="header-text">Edit Company</h1></CardHeader>
          <div className="" style={{ display: 'flex' }}>
            <div className="col-md-12 pb-4 pt-4">
              <h3 id='funding-rounds' >{this.state.id == 'add' ? 'Add' : 'Update'} Employee Data</h3>
            </div>
          </div>
          <CardBody style={{ padding: 30, paddingTop: 20 }}>
            <div style={{ marginLeft: 0 }}>
              <Formik
                enableReinitialize={true}
                initialValues={{
                  name,
                  title
                }}
                validationSchema={this.ValidationSchema}
                onSubmit={this.onSubmit}
              >
                {({ errors, touched, values, handleChange, handleSubmit, isValid, setTouched }) => (
                  <Form onSubmit={handleSubmit} noValidate name='subscribeForm' style={{ width: "100%" }}>
                    <FormGroup className="custom-form-group">
                      <Label className="custom-label">Name:</Label>
                      <Input type="text"
                        name="name"
                        id="name"
                        placeholder=""
                        autoFocus={false}
                        onChange={handleChange}
                        required
                        value={values.name} />
                      <FormFeedback>{errors.name}</FormFeedback>
                    </FormGroup>
                    <FormGroup className="custom-form-group">
                      <Label className="custom-label">Title:</Label>
                      <Input type="text"
                        name="title"
                        id="title"
                        placeholder=""
                        autoFocus={false}
                        onChange={handleChange}
                        required
                        value={values.title} />
                      <FormFeedback>{errors.title}</FormFeedback>
                    </FormGroup>
                    <FormGroup style={{ float: "right" }}>
                      <Button
                        // onClick={() => this.touchAll(setTouched, errors)} 
                        style={{ width: 150 }}
                        type="submit" color="success" className="mr-1">{id == 'add' ? 'Add' : 'Save'}</Button>
                    </FormGroup>
                  </Form>
                )}
              </Formik>
            </div>
          </CardBody>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  growjo_id: state.company.data.id,
  company: state.company.data.company_name,
  employee: state.company.data.executive_contacts
})
export default withRouter(connect(mapStateToProps, { updateEmployeeById, getCompanybyName, addEmployee })(EmployeeTable));



// WEBPACK FOOTER //
// ./client/src/views/EditCompany/Employee/index.js